import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ScriptLoader from "../Helpers/ScriptLoader";
import AlgoliaStylingWrapper from "./AlgoliaStylingWrapper";

const StyledSearchInput = styled.input`
  border-radius: 3px;
  height: 2rem;
  padding: 0 10% 0 5%;
  border: ${({ theme }) => theme.colors.green1} solid 1px;
  &:focus {
    outline: none;
  }
`;

const AlgoliaSearchInput = () => {
  const algoliaSrc = "https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js";
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      window.docsearch({
        apiKey: '457c30f8cd6d1b2013f3cf3c69212a2b',
        indexName: 'modeanalytics',
        inputSelector: '.typeahead',
        // debug: true // Set debug to true if you want to inspect the dropdown
      });
    }
  }, [isLoaded]);

  return (
    <AlgoliaStylingWrapper>
      <ScriptLoader
        scriptSrc={algoliaSrc}
        isLoadedCallback={() => setIsLoaded(true)}
      />
      <StyledSearchInput
        className="typeahead"
        placeholder="Search"
      ></StyledSearchInput>
    </AlgoliaStylingWrapper>
  );
};

export default AlgoliaSearchInput;
